import { connect } from 'react-redux';

import {
    changeShoppingList,
    getShoppingLists,
    toggleDeleteListConfirmation,
    deleteShoppingList,
    toggleEditList,
    editShoppingListName,
    clearProducts,
} from 'Favourites/store/actions';

import {
    selectLists,
    selectSelectedListId,
} from 'store/reducers/data/shoppingList';

import {
    selectIsLoggedIn,
} from 'store/reducers/data/user';

import { LIST_TYPE } from 'Favourites/store/constants';

import appStorage from 'helpers/AppStorage';

const mapStateToProps = (state) => {
    return {
        lists: selectLists(state),
        selectedList: selectSelectedListId(state),
        isLogged: selectIsLoggedIn(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeList: (value) => {
            dispatch(changeShoppingList(value));
            dispatch(clearProducts());
            appStorage('selectedList', value);
        },
        getShoppingLists: (selectedList) => {
            dispatch(getShoppingLists(selectedList));
        },
        toggleListDeleteConfirmation: (list, value) => {
            dispatch(toggleDeleteListConfirmation(list, value));
        },
        deleteShoppingList: (list) => {
            dispatch(deleteShoppingList(list));

            if (list.toString() === appStorage('selectedList') || appStorage('selectedList') === null) {
                appStorage('selectedList', null);
                dispatch(clearProducts());
            }
        },
        toggleListEdit: (list, value) => {
            dispatch(toggleEditList(list, value));
        },
        editShoppingListName: (list, value) => {
            dispatch(editShoppingListName(list, LIST_TYPE, value));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
